import { SearchDispatch } from "./SearchDispatch";
import { useSearchStore } from "./useSearchStore";

export function useSearchDispatch(): SearchDispatch {
    return useSearchStore()[1];
}
